import React from "react";
import { object, arrayOf } from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";
// eslint-disable-next-line import/no-cycle
import { Button as SharedButton } from "../Button";
import * as sharedStyles from "./CallToActionSections.module.scss";

let cx = classNames.bind(sharedStyles);

const CallToActionSections = ({ sections, customButton, styles }) => {
	let Button = null;

	cx = classNames.bind(merge(sharedStyles, styles));

	if (customButton) {
		Button = customButton;
	} else {
		Button = SharedButton;
	}

	return (
		sections && (
			<div className={cx("CtaSectionsContainer", "CtaSectionsContainerCustom")}>
				{sections.map(section => (
					<div
						key={section.id}
						className={
							section.halfWidth
								? cx("ctaSection", "ctaSectionCustom", "sectionHalf", "sectionHalfCustom")
								: cx("ctaSection", "ctaSectionCustom", "sectionFull", "sectionFullCustom")
						}>
						<div>
							{section.title && (
								<h2 className={cx("sectionTitle", "sectionTitleCustom")}>{section.title}</h2>
							)}
							{section.subtitle && (
								<span className={cx("sectionSubtitle", "sectionSubtitleCustom")}>
									{section.subtitle}
								</span>
							)}
						</div>
						{section.buttons && (
							<div
								className={cx(
									"buttonWrapper",
									section.buttonsHalfWidth ? "buttonWrapperCols" : ""
								)}>
								{section.buttons.map(button => (
									<div className={cx("buttonWrapperCol")}>
										<Button
											key={button.id}
											theme={button.variant || "primary"}
											size="lg"
											full
											outline={button.invertButtonStyle}
											to={button.link && button.link}
											label={button.text}
											icon={button.iconName}
										/>
									</div>
								))}
							</div>
						)}
					</div>
				))}
			</div>
		)
	);
};

CallToActionSections.propTypes = {
	sections: arrayOf(object),
	customButton: object,
	styles: object,
};
CallToActionSections.defaultProps = {
	sections: [],
	customButton: null,
	styles: null,
};

export default CallToActionSections;
export { CallToActionSections };
